import { Clock, Mail, Phone, User } from 'lucide-react';
import { Appointment, Client } from '../types';

interface AppointmentCardProps {
  appointment?: Appointment | null;
  client: Client;
  onClick: () => void;
}

const statusColors = {
  pendiente: 'bg-gray-100 text-gray-700',
  'en-curso': 'bg-[#E91E8C]/10 text-[#E91E8C]',
  finalizado: 'bg-gray-200 text-gray-600'
};

const statusLabels = {
  pendiente: 'Pendiente',
  'en-curso': 'En Curso',
  finalizado: 'Finalizado'
};

export function AppointmentCard({ appointment, client, onClick }: AppointmentCardProps) {
  return (
    <div
      onClick={onClick}
      className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 hover:shadow-md transition-shadow cursor-pointer active:scale-[0.98] transition-transform"
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <Clock className="w-5 h-5 text-[#E91E8C]" />
          <span className="text-lg font-semibold text-[#2d2d2d]">
            {appointment?.time || 'Cliente'}
          </span>
        </div>
        <span
          className={`px-3 py-1 rounded-full text-sm ${
            appointment ? statusColors[appointment.status] : 'bg-gray-100 text-gray-700'
          }`}
        >
          {appointment ? statusLabels[appointment.status] : 'Sin cita hoy'}
        </span>
      </div>

      <div className="flex items-center gap-2 mb-3">
        <User className="w-4 h-4 text-gray-500" />
        <p className="text-base font-medium text-[#2d2d2d]">
          {client.firstName} {client.lastName}
        </p>
      </div>

      {appointment ? (
        <div className="space-y-1">
          {appointment.treatments.map((treatment, index) => (
            <div key={index} className="text-sm text-gray-600 pl-6">
              - {treatment}
            </div>
          ))}
        </div>
      ) : (
        <div className="space-y-2 pl-6">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Phone className="w-4 h-4 text-gray-400" />
            <span>{client.phone || 'Telefono no disponible'}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Mail className="w-4 h-4 text-gray-400" />
            <span>{client.email || 'Email no disponible'}</span>
          </div>
        </div>
      )}
    </div>
  );
}
